import { confirmWallet } from '@/utils/util';
import { useWallet } from '@solana/wallet-adapter-react';
import base58 from 'bs58';

export const useSolanaConnect = () => {
  const { disconnect, signMessage } = useWallet();

  const confirmWalletWithSigature = async (connection) => {
    const msg = new TextEncoder().encode(
      `Sign in to Agent.land: ${connection.nonce}`,
    );

    const sig = await signMessage?.(msg);
    const res = base58.encode(sig as Uint8Array);
    const signedWallet = { ...connection, signature: res };
    return confirmWallet({ data: signedWallet });
  };

  const logOut = async () => {
    if (typeof disconnect === 'function') {
      await disconnect();
    }
  };

  return {
    logOut,
    confirmWalletWithSigature,
  };
};
